import { Switch } from "react-router-dom";
import EmailsContentForm from "../../pages/templateEmails/EmailsContentForm";
import EmailsList from "../../pages/templateEmails/EmailsList";

import Route from "../Route";

export default function TemplateEmails() {
  return (
    <>
      <Switch>
        <Route path="/templateemails/cadastro" component={EmailsContentForm} />
        <Route path="/templateemails/listagem" component={EmailsList} />
      </Switch>
    </>
  );
}
